import React from "react";

export default function FacebookIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 3.5H4.5C3.94687 3.5 3.5 3.94687 3.5 4.5V27.5C3.5 28.0531 3.94687 28.5 4.5 28.5H27.5C28.0531 28.5 28.5 28.0531 28.5 27.5V4.5C28.5 3.94687 28.0531 3.5 27.5 3.5ZM26.5 26.5H20.7469V18.8188H23.9969L24.4844 15.0469H20.7469V12.6375C20.7469 11.5437 21.05 10.8 22.6156 10.8H24.6125V7.425C24.2656 7.37813 23.0813 7.275 21.7 7.275C18.8188 7.275 16.8469 9.03437 16.8469 12.2625V15.0437H13.5906V18.8156H16.85V26.5H5.5V5.5H26.5V26.5Z"
        fill="#EF60A3"
      />
    </svg>
  );
}
